var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.725 7.7L7.7 17.7C7.78333 17.9 7.85417 18.1083 7.9125 18.325C7.97083 18.5417 8 18.7667 8 19C8 19.8333 7.7125 20.5417 7.1375 21.125C6.5625 21.7083 5.85 22 5 22C4.16667 22 3.45833 21.7083 2.875 21.125C2.29167 20.5417 2 19.8333 2 19C2 18.15 2.29167 17.4375 2.875 16.8625C3.45833 16.2875 4.16667 16 5 16C5.23333 16 5.45833 16.0292 5.675 16.0875C5.89167 16.1458 6.1 16.2167 6.3 16.3L16.3 6.275C16.2167 6.075 16.1458 5.87083 16.0875 5.6625C16.0292 5.45417 16 5.23333 16 5C16 4.15 16.2917 3.4375 16.875 2.8625C17.4583 2.2875 18.1667 2 19 2C19.85 2 20.5625 2.2875 21.1375 2.8625C21.7125 3.4375 22 4.15 22 5C22 5.83333 21.7125 6.54167 21.1375 7.125C20.5625 7.70833 19.85 8 19 8C18.7667 8 18.5458 7.97083 18.3375 7.9125C18.1292 7.85417 17.925 7.78333 17.725 7.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLine);
export default __webpack_public_path__ + "static/media/icon-line.56be3c1de2b7f26d8ae61c5b57a2d6db.svg";
export { ForwardRef as ReactComponent };